<template>
  <div class="home">
    <Header/>
    <div class="content-box">
      <div class="logo"><img class="pointer" src="../assets/image/99.png" alt=""></div>
      <div class="main-nav">
          <img class="pointer" @click="toDiv('hotDiv')" src="../assets/image/redian.png" alt="">
          <img class="pointer" @click="toDiv('jpDiv')"  src="../assets/image/jingpin.png" alt="">
          <img class="pointer" @click="toDiv('testDiv')"  src="../assets/image/shiti.png" alt="">
          <img class="pointer" @click="toDiv('hotDiv')"  src="../assets/image/baokao.png" alt="">
      </div>
      <div id="hotDiv" class="art-card" style="height:400px;">
        <div class="pre-icon">
          <span class="art-title">
            <img src="../assets/image/index/pre-icon.png" />
            热点推荐
            </span>
        </div>
        <div class="art-list">

            <p v-for="item in hotList" :key="item.id"><a  target="_blank" :href="item.url">{{item.title}}</a></p>
  
        </div>
      </div>
      <div id="jpDiv" class="art-card">
        <div class="pre-icon">
          <span class="art-title">
            <img src="../assets/image/index/pre-icon.png" />
            精品同步区
            </span>
        </div>
        <div class="art-area">
          <div class="area fl">
            <div class="nav-div">
              <img class="nav" src="../assets/image/nav.png"/>
              <div class="area-title">优秀作文</div>
            </div>
            <div class="area-item">
                <div v-for="item in jpzw" :key="item.id">
                  <div class="t"><a :href="item.url" target="_blank" class="text pointer">{{item.title}}</a></div>
                </div>
                
            </div>
          </div>

        <div class="area fr">
            <div class="nav-div">
              <img class="nav" src="../assets/image/nav.png"/>
              <div class="area-title">知识点总结</div>
            </div>
            <div class="area-item">
                <div v-for="item in jpzs" :key="item.id">
                  <div class="t"><a :href="item.url" target="_blank" class="text pointer">{{item.title}}</a></div>
                </div>
            </div>
          </div>
        <div  class="area fl">
            <div class="nav-div">
              <img class="nav" src="../assets/image/nav.png"/>
              <div class="area-title">同步练题裤</div>
            </div>
            <div class="area-item">
                <div v-for="item in jptk" :key="item.id">
                  <div class="t"><a :href="item.url" target="_blank" class="text pointer">{{item.title}}</a></div>
                </div>
            </div>
          </div>

        <div class="area fr">
            <div class="nav-div">
              <img class="nav" src="../assets/image/nav.png"/>
              <div class="area-title">公式定理大全</div>
            </div>
            <div class="area-item">
                <div v-for="item in jpdl" :key="item.id">
                  <div class="t"><a :href="item.url" target="_blank" class="text pointer">{{item.title}}</a></div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div id="testDiv" class="art-card" style="height:400px;">
        <div class="pre-icon">
          <span class="art-title">
            <img src="../assets/image/index/pre-icon.png" />
            试题免费下载区
            </span>
        </div>
        <div class="shiti-list">
          <div  class="st-item pointer">
            <a :href="gk.url" target="_blank" class="item-text">高考真题集</a>
          </div>
          <div class="st-item pointer">
            <a :href="zk.url" target="_blank" class="item-text">中考真题集</a>
          </div>
          <div class="st-item pointer">
            <a :href="qz.url" target="_blank" class="item-text">期中真题集</a>
          </div>
          <div class="st-item pointer">
            <a :href="qm.url" target="_blank" class="item-text">期末真题集</a>
          </div>
        </div>
      </div>

      <div id="zxDiv" class="art-card" style="height:400px;">
        <div class="pre-icon">
          <div class="art-title">
            <img src="../assets/image/index/pre-icon.png" />
            报考资讯
            <div class="title-tab">
              <div class="tab-item pointer"  :class="{active: queryInfo.currentNav == 4}" @click="goNav(4)" >
                小学资讯
              </div>
              <div class="tab-item pointer"  :class="{active: queryInfo.currentNav == 3}" @click="goNav(3)">
                初中资讯
              </div>
              <div class="tab-item pointer"  :class="{active: queryInfo.currentNav == 2}" @click="goNav(2)">
                高中资讯
              </div>
              <div class="tab-item pointer"  :class="{active: queryInfo.currentNav == 1}" @click="goNav(1)">
                志愿填报
              </div>
            </div>
          </div>
        </div>
        <div v-if="queryInfo.currentNav == 1" class="art-list">
          <p v-for="item in zyList" :key="item.id"><a :href="item.url" target="_blank">{{item.title}}</a></p>
        </div>
        <div v-if="queryInfo.currentNav == 2" class="art-list">
          <p v-for="item in gzList" :key="item.id"><a :href="item.url" target="_blank">{{item.title}}</a></p>
        </div>
        <div v-if="queryInfo.currentNav == 3" class="art-list">
          <p v-for="item in czList" :key="item.id"><a :href="item.url" target="_blank">{{item.title}}</a></p>
        </div>
        <div v-if="queryInfo.currentNav == 4" class="art-list">
          <p v-for="item in xxList" :key="item.id"><a :href="item.url" target="_blank">{{item.title}}</a></p>
        </div>
      </div>

    </div>
    <!-- <HelloWorld msg="Welcome to Your Vue.js + TypeScript App"/> -->
    <div class="home-footer">
      <Footer/>
    </div>
  </div>
</template>


<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
  data() {
    return {
      queryInfo:{
        currentNav: 1
      },
      hotList:[],
      jpzs:[],
      jpzw:[],
      jptk:[],
      jpdl:[],
      gk:{},
      zk:{},
      qz:{},
      qm:{},
      zyList:[],
      gzList:[],
      czList:[],
      xxList:[]
    }
  },
  methods:{
      toDiv(id){
        document.getElementById(id).scrollIntoView()
      },
      goNav(num){
         this.queryInfo.currentNav = num
      },
      async getHot(){
         this.hotList = await this.getResult(1,null,null);
         this.jpzw = await this.getResult(2,1,null);
         this.jpzs = await this.getResult(2,2,null);
         this.jptk = await this.getResult(2,3,null);
         this.jpdl = await this.getResult(2,4,null);
         var gk = await this.getResult(3,1,null);
         this.gk = gk[0];
         var zk = await this.getResult(3,2,null);
         this.zk =zk[0];
         var qz = await this.getResult(3,3,null);
         this.qz = qz[0];
         var qm = await this.getResult(3,4,null);
         this.qm = qm[0];
          this.zyList = await this.getResult(4,1,null);
         this.gzList = await this.getResult(4,2,null);
         this.czList = await this.getResult(4,3,null);
         this.xxList = await this.getResult(4,4,null);
      },
      async getAllList(){
         var list = await this.getResult(null,null,null);
         var hotList = [];
         var jpzs = [];
         var jpzw = [];
         var jptk = [];
         var jpdl = [];
         var gk = {};
         var zk = {};
         var qz = {};
         var qm = {};
         var zyList = [];
         var gzList = [];
         var czList = [];
         var xxList = [];
         for(var i in list){
           var type = list[i].type;
           var subType = list[i].subType;
           if(type==1){
             hotList.push(list[i]);
           }else if(type==2){
             if(subType==1){
               jpzw.push(list[i]);
             }
             if(subType==2){
               jpzs.push(list[i]);
             }
             if(subType==3){
               jptk.push(list[i]);
             }
             if(subType==4){
               jpdl.push(list[i]);
             }
           }else if(type==3){
             if(subType==1){
               gk = list[i];
               console.log(gk)
             }
             if(subType==2){
               zk = list[i];
             }
             if(subType==3){
               qz = list[i];
             }
             if(subType==4){
               qm = list[i];
             }
           }else if(type==4){
             if(subType==1){
               zyList.push(list[i]);
             }
             if(subType==2){
               gzList.push(list[i]);
             }
             if(subType==3){
               czList.push(list[i]);
             }
             if(subType==4){
               xxList.push(list[i]);
             }
           }
         }
         this.hotList = hotList;
         this.jpzw = jpzw;
         this.jpzs = jpzs;
         this.jptk = jptk;
         this.jpdl = jpdl;
         this.gk = gk;
         this.zk = zk;
         this.qz = qz;
         this.qm = qm;
         this.zyList = zyList;
         this.gzList = gzList;
         this.czList = czList;
         this.xxList = xxList;
      },
      async search(type,subType,contentType) {
        console.log(contentType)
        var data = {
                  pageNum: 1,
                  pageSize: 2,
                  type:type,
                  subType:subType
              };

          var res = await this.$axios({
              // 默认请求方式为get
              method: 'post',
              url: 'https://jzl.xcx.skyedu.cn/webContent/list',
              //url: 'http://192.168.60.135:9001/webContent/list',
              // headers: {
              //     'Content-Type': 'application/x-www-form-urlencoded'
              // },
              data: data,
          });
          return res;
      },
      async getResult(type,subType,contentType){
        var result = await this.search(type,subType,contentType);
        console.log(result);
        var list = result.data.data.records;
        return list;
      }
  },
  created(){
    this.getHot();
  },
  components: {
    Header,
    Footer
  },
}
</script>

<style lang="less" scoped>
  .fl{
    float: left
  }
  .fr{
    float: right
  }
  .content-box {
    width: 62%;
    margin: 16px auto 0;
    .logo {
      // width: 97%;
      margin: 0 auto 21px;
      img {
        width: 100%;
      }
    }
    .main-nav {
      img {
        width: 25%;
      }
      display: flex;
    }
    .art-card {
      margin-top: 40px;
      margin-bottom: 40px;
      height: 450px;
      width: 100%;
      //background: url(../assets/image/index/juxing.png) no-repeat;
      //width: 1147px;
      height: 680px;
      //background: #FFFFFF;
      box-shadow: 0px 0px 18px 2px rgba(14, 85, 179, 0.27);
      border-radius: 10px;
      .pre-icon {
        img {
          vertical-align: middle;
        }
        padding-top: 50px;
        padding-left: 60px;
        text-align: left;
        .art-title {
          font-size: 38px;
          font-weight: bold;
          color: #343434;
        }
        .title-tab {
          font-size: 21px;
          position: relative;
          top: -40px;
          .tab-item {
            font-weight:500;
            text-align: center;
            width: 125px;
            height: 41px;
            border-radius: 17px;
            line-height: 41px;
            float: right;
            margin-right: 20px;
          }
          .active {
            color: #fff;
            background: #1663E5;
          }
        }
      }
      .art-list {
        margin-top: 50px;
        margin-left:110px;
        margin-right: 50px;
        text-align: left;
        color: #676767;
        font-size: 24px;
        a {
          color: #676767;
        }
      }
      .art-area {
        height: 500px;
        margin-top: 30px;
        margin-left:60px;
        margin-right: 60px;
        padding-top: 5px;
        padding-left: 5px;
        .area {
          width: 48%;
          height: 233px;
          margin-bottom: 40px;
          background-color: #F2F4FF;
          .nav-div {
            text-align: center;
            position: relative;
            top:-11px;
            .nav {
              width: 204px;
              margin-left: auto;
              margin-right: auto;
            }
          .area-title {
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #FFFFFF;
            position: relative;
            top:-48px;
            }
          }
          .area-item {
            display: flex;
            align-content: center;
            justify-content: space-around;
            flex-wrap: wrap;
          }
          .t{
            margin-bottom: 10px;
            width: 126px;
            height: 33px;
            border: 2px solid #4285EC;
            border-radius: 22px;
            text-align: center;
            .text {
              width: 87px;
              height: 20px;
              line-height: 33px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #76777B;
            }
          }
        }
      }
      .shiti-list{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding-top: 40px;
        text-align: center;
        .st-item{
          width: 20%;
          background: url("../assets/image/file.png") no-repeat;
          background-size: 100%;
          height: 244px;
          .item-text {
            position: relative;
            top:45%;
            font-size: 24px;
            font-weight: 400;
            color: white;
          }
        }
      }
    }
    .pointer {
      cursor:pointer;
    }
  }

  .border-radius-linear-gradient {
      width: 87px;
      height: 20x;
      position: relative;
      border: 4px solid transparent;
      background-color: transparent;
      border-radius: 5px;
      background-clip: padding-box;
  }
  .border-radius-linear-gradient::after {
      content: "";
      display: block;
      position: absolute;
      top: -4px;
      right: -4px;
      bottom: -4px;
      left: -4px;
      border-top-right-radius: 5px;
      border-radius: 5px;
      background: linear-gradient(135deg, red, blue);
      z-index: -1;
  }
  .border-radius-linear-gradient-content {
      width: 87px;
      height: 20px;
      background-color: yellow;
      border-radius: 4px;
  }

  .home-footer {
    width: 100%;
    height: 455px;
    background: linear-gradient(0deg, #001731, #0D1241, #073371, #4281D9);
    display: flex;
    align-items: center;
    justify-items: center;
  }
</style>